<template>
  <div class="row">
    <ImageAndTitleBlock :title="item.name" :image="item.image" :entity="item.entity" :slug="item.slug"
                        v-for="item in items"/>
  </div>
</template>

<script>
import ImageAndTitleBlock from "@/components/molecules/ImageAndTitleBlock.vue";

export default {
  props: {
    items: Array
  },
  components: {ImageAndTitleBlock}
}
</script>

<style scoped>
.row {
  max-width: 100%;
  overflow-x: auto;
}
</style>
